import Image from 'next/image'
import {FC} from 'react'

import {brandMonitoringPlatforms} from '@/content/brand-monitoring/constants'
import {BrandSubscriptionPlatform} from '@/utils/brand-subscription/constants'

type MonitoringPlatformIconProps = {platform: BrandSubscriptionPlatform; size?: number}

export const MonitoringPlatformIcon: FC<MonitoringPlatformIconProps> = ({platform, size = 20}) => {
  const {imageSrc, imageAlt} = brandMonitoringPlatforms[platform]

  return (
    <Image
      src={imageSrc}
      alt={imageAlt}
      style={{objectFit: 'contain'}}
      width={size}
      height={size}
    />
  )
}
